import { render } from "./sessionCard.vue?vue&type=template&id=27c67743"
import script from "./sessionCard.vue?vue&type=script&lang=js"
export * from "./sessionCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__